<template>
    <div class="text-left">
        <p>{{ descriptionText }}</p>
        <div class="alert alert-success" v-if="copied">{{ copyConfirmationText }}</div>
        <div class="input-group mb-2">
            <input
                :aria-label="descriptionText"
                class="form-control input-monospace"
                data-autoselect
                :inputClass="inputClass"
                readonly type="text"
                :value="link"
            >
            <div class="input-group-btn">
                <button
                    class="btn"
                    :class="btnClass"
                    type="button"
                    v-clipboard:copy="link"
                    v-clipboard:success="onCopy"
                >
                    Copy!
                </button>
            </div>
        </div>
        <p class="bold">More ways to share:</p>
        <social-sharing
            inline-template
            class="mb-2"
            title="Hey, do you want to participate in this event?"
            :url="link"
        >
            <div class="row">
                <div class="col-md-4">
                    <network
                        class="btn btn-success btn-sm mb5 btn-block"
                        network="whatsapp"
                        tag="button"
                        type="button"
                    >
                        <i class="fab fa-whatsapp"></i>WhatsApp
                    </network>
                </div>
                <div class="col-md-4 mr-auto">
                    <network
                        class="btn btn-success btn-sm mb5 btn-block"
                        network="sms"
                        tag="button"
                        type="button"
                    >
                        <i class="fas fa-sms"></i>SMS
                    </network>
                </div>
                <div class="col-md-4 mr-auto">
                    <network
                        class="btn btn-success btn-sm mb5 btn-block"
                        network="email"
                        tag="button"
                        type="button"
                    >
                        <i class="fas fa-inbox"></i> Share
                    </network>
                </div>


            </div>
        </social-sharing>
        <display-referral-benefits
            :referral-scheme="referralScheme"
            referral-text="your friend"
            referrer-text="you"
            :user-referrer-code="userReferrerCode"
            v-if="referralScheme"
        ></display-referral-benefits>
    </div>

</template>

<script>
import {money} from '../Utility/filters/money';
import SocialSharing from 'vue-social-sharing';
import DisplayReferralBenefits from "../ReferralSchemes/DisplayBenefits.vue";

export default {
    name: "FriendInviter",

    components: {
        DisplayReferralBenefits,
        SocialSharing,
    },

    filters: {
        money,
    },


    props: {
        /**
         * The URL that will be shared when users copy/share
         */
        link: {
            type: String,
            required: true,
        },
        /**
         * Indicates which page is hosting the share component
         * Used to customize behavior based on context
         */
        hostPage: {
            type: String,
            required: false,
            default: 'landing-page',
            validator: function (value) {
                return ['landing-page', 'booking-confirmation', 'user-profile'].indexOf(value) !== -1
            }
        },
        /**
         * Configuration for the referral program
         * Set to null when no referral program is active
         */
        referralScheme: {
            type: Object,
            required: false,
            default: null,
        },
        /**
         * Controls the size of buttons and inputs
         * Possible values: 'sm', 'md', 'lg'
         */
        size: {
            type: String,
            required: false,
            default: 'md',
            validator: function (value) {
                return ['sm', 'md', 'lg'].indexOf(value) !== -1
            }
        },
        /**
         * The current user's referrer code to be included in shared links
         */
        userReferrerCode: {
            type: String,
            required: true,
        },

    },
    computed: {
        btnClass() {
            return "btn-" + this.size;
        },
        inputClass() {
            return "input-" + this.size;
        },
        descriptionText() {
            // For user-profile page
            if (this.hostPage === 'user-profile') {
                if (!this.referralScheme) {
                    return 'Share this link with friends so they can discover our events!';
                }

                let baseText = `Earn ${this.$options.filters.money(this.referralScheme.credit_amount_per_signup, this.referralScheme.currency)} in credit for each person who registers on any event using your unique link.`;

                if (this.referralScheme.side_of_benefit === 'both') {
                    baseText += ` The person using this link or your unique code will also receive a discount on their registration.`;
                }

                return baseText;
            }

            // For landing-page or booking-confirmation (original behavior)
            if (!this.referralScheme) {
                return 'Share this event with friends and colleagues! Send them the link or use the social buttons below to spread the word. The more people who join, the better the experience for everyone.';
            }

            let baseText = `Share this event and earn rewards! Get ${this.$options.filters.money(this.referralScheme.credit_amount_per_signup, this.referralScheme.currency)} in credit for each friend who registers using your unique link.`;

            if (this.referralScheme.side_of_benefit === 'both') {
                baseText += ` They'll also receive a discount on their registration.`;
            }

            return baseText + ' Share now to start earning!';
        },
        copyConfirmationText() {
            if (this.referralScheme === null) {
                return 'Link copied! Share it with friends to spread the word.';
            }

            return `Link copied! Share it to earn ${this.$options.filters.money(this.referralScheme.credit_amount_per_signup, this.referralScheme.currency)} in credit for each signup.`;
        }
    },
    data() {
        return {
            copied: false,
            emails: [],
        }
    },
    methods: {
        onCopy() {
            this.copied = true;
            setInterval(() => {
                this.$root.$emit('bv::hide::modal', 'inviteModal')
                this.copied = false;
            }, 3000)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/FriendInviter.vue